var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"image-container",style:({
    background: _vm.imageUrl
      ? 'linear-gradient(to bottom right, rgba(62, 87, 153, 0.5),rgba(18, 11, 63, 0.5)), url(' +
        (_vm.imageUrl || '') +
        ') center center no-repeat'
      : 'linear-gradient(to bottom right, rgba(62, 87, 153, 0.5),rgba(18, 11, 63, 0.5))'
  }),attrs:{"max-height":"300","min-height":"300"}},[_c('div',{staticClass:"white--text pa-12 text-center",style:({ position: 'relative' })},[_c('base-heading',[_vm._v(" "+_vm._s(_vm.topText)+" ")]),_c('base-text',{staticClass:"mb-5"},[_vm._v(" "+_vm._s(_vm.topSubText)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }